import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect } from "react";
import { makeStyles, Typography, Button, MobileContainerAnimation, SwitchStatus, LinkAnimation } from "../../../";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import RoomIcon from "@material-ui/icons/Room";
import CircularProgress from "@material-ui/core/CircularProgress";
import ReactMapGL, { Marker } from "react-map-gl";
import moment from "moment";
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      minHeight: "100%"
    },
    breadcrumb: {
      display: "flex",
      flexFlow: "row nowrap",
      alignItems: "center",
      height: "60px",
      position: "fixed",
      width: "100%",
      zIndex: "10",
      background: theme.palette.background["default"]
    },
    content: {
      padding: "80px 8px 12px 8px",
      width: "100%"
    },
    actions: {
      display: "flex",
      "justify-content": "space-between",
      "margin-bottom": "15px"
    },
    checkInContainer: {
      width: "45%",
      padding: "10px",
      "margin-bottom": "15px",
      background: "none",
      display: "flex",
      "flex-direction": "column",
      "justify-content": "center"
    },
    loadingContainer: {
      width: "100%",
      height: "100%",
      display: "flex",
      "align-items": "center",
      "justify-content": "center"
    }
  };
});

var MobileShift = function MobileShift(props) {
  // console.log("MobileCampusShift props", props);
  var action = props.action,
      translation = props.translation,
      mapboxApiAccessToken = props.mapboxApiAccessToken,
      handleSaveShift = props.handleSaveShift,
      handleDownloadInfo = props.handleDownloadInfo,
      data = props.data;

  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      isLoading = _useState2[0],
      setIsLoading = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      canSave = _useState4[0],
      setCanSave = _useState4[1];

  var _useState5 = useState({
    latitude: 40.416775,
    longitude: -3.70379,
    zoom: 5
  }),
      _useState6 = _slicedToArray(_useState5, 2),
      viewport = _useState6[0],
      setViewport = _useState6[1];

  var classes = useStyles();
  useEffect(function () {
    // navigator.geolocation.getCurrentPosition(success, error, options);
    navigator.geolocation.getCurrentPosition(function (position) {
      setIsLoading(false);
      setViewport({
        latitude: position.coords.latitude,
        longitude: position.coords.longitude,
        zoom: 15 // transitionDuration: 100,
        // transitionInterpolator: new FlyToInterpolator(),
        // transitionEasing: d3.easeCubicIn,

      });
      setCanSave(true);
    }, function (err) {
      return console.warn("ERROR(" + err.code + "): " + err.message);
    }, {
      enableHighAccuracy: true,
      timeout: 10000,
      maximumAge: 0
    });
  }, [data, action]);

  var savePosition = function savePosition() {
    handleSaveShift({
      date: moment().format(),
      location: {
        type: "Point",
        coordinates: [viewport.latitude, viewport.longitude]
      }
    });
    setCanSave(false);
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MobileContainerAnimation, Object.assign({
    classes: classes.root
  }, props.routerState || null), /*#__PURE__*/React.createElement("div", {
    className: classes.breadcrumb
  }, /*#__PURE__*/React.createElement(LinkAnimation, props.link, /*#__PURE__*/React.createElement(ChevronLeftIcon, {
    fontSize: "large"
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.textFlexWidth
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, action === "checkin" ? "Check in " : action === "checkout" ? "Check out " : ""))), /*#__PURE__*/React.createElement("div", {
    className: classes.content
  }, /*#__PURE__*/React.createElement(SwitchStatus, {
    status: props.status,
    action_download: function action_download() {
      handleDownloadInfo();
      return null;
    },
    success: function success() {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: classes.actions
      }, /*#__PURE__*/React.createElement(LinkAnimation, props.link, /*#__PURE__*/React.createElement(Button, {
        "data-cy": "cancel",
        type: "button",
        size: "medium",
        className: classes.mr30,
        color: "secondary",
        variant: "outlined"
      }, translation ? translation.buttons.cancel : "Cancel")), /*#__PURE__*/React.createElement(Button, {
        "data-cy": "submit",
        size: "medium",
        color: "primary",
        variant: "outlined",
        onClick: savePosition,
        disabled: !canSave
      }, translation ? translation.buttons.save : "Save")), action === "checkout" && /*#__PURE__*/React.createElement("div", {
        className: classes.checkInContainer
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "button",
        color: "primary"
      }, "Check in"), /*#__PURE__*/React.createElement(Typography, {
        variant: "caption",
        color: "white"
      }, data && moment(data.start.date).format("DD/MM/YYYY HH:mm"))), /*#__PURE__*/React.createElement(ReactMapGL, Object.assign({}, viewport, {
        width: "100%",
        height: "80%",
        mapboxApiAccessToken: mapboxApiAccessToken,
        onViewportChange: function onViewportChange(viewport) {
          return setViewport({
            viewport: viewport
          });
        }
      }), isLoading ? /*#__PURE__*/React.createElement("div", {
        className: classes.loadingContainer
      }, /*#__PURE__*/React.createElement(CircularProgress, {
        size: 100
      })) : viewport.latitude && viewport.longitude && /*#__PURE__*/React.createElement(Marker, {
        latitude: viewport.latitude,
        longitude: viewport.longitude,
        offsetLeft: -20,
        offsetTop: -10
      }, /*#__PURE__*/React.createElement(RoomIcon, {
        fontSize: "large",
        color: "primary"
      }))));
    }
  }))));
};

export { MobileShift };